export default __webpack_public_path__ + "music.8b5325e9.png";